/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pilot_Ended_Sign_OutInputs */



/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Pilot_Ended_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const pilot_ended_sign_out = /** @type {((inputs?: Pilot_Ended_Sign_OutInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pilot_Ended_Sign_OutInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Afmelden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se déconnecter")
	return /** @type {LocalizedString} */ ("Sign out")
});